import React, { useState, useEffect } from 'react';
import TopTitle from './TopTitle';
import axios from 'axios';
import { comma } from './common'
import Pagination from "react-js-pagination";
import Bottom_menu from "./Bottom_menu";
import { formatDate } from './common';
import { instance } from './common';
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
import calendar from './img/sigong_nav/month.png'

function totalPrice(data,discount){
    let price = 0;
    data.forEach(function(v){
        price += Number(v.s_member_price);
        if(v.c_option){
            JSON.parse(v.c_option).forEach(function(items){
                price += Number(items.price);
            });
        }
    });
    price =  price-discount;
    return comma(price);
}


function MakeBtn({ status, gumsu, enddate, gubun, r_id, history, s_id}) {
    
    let str = '';
    let classStr = '';
    const btnRadius = {
        borderRadius: '5px'
    }
    if (gumsu === null && enddate === null && gubun === '현장') {
        str = '현장결제';
        classStr = 'btn btn-success col-6'
    } else if (gumsu === null && enddate === null && gubun === '온라인') {
        str = '앱 결제';
        classStr = 'btn btn-danger col-6'
    } else if (gumsu === null && enddate === null && gubun === '') {
        str = '신청완료';
        classStr = 'btn btn-info col-6'
    }

    if (status === '입고완료') {
        str = '입고완료';
        classStr = 'btn btn-warning col-6 text-white'
    } else if (status === '검수완료') {
        str = '검수완료';
        classStr = 'btn btn-primary col-6'
    } else if (status === "작업완료") {
        str = '작업완료';
        classStr = 'btn btn-secondary col-6'
    }
    const [value, onChange] = useState(new Date());
    const goPage = (e) => {
        const rr_id = e.target.dataset.id;
        if(e.target.dataset.name === "신청완료"){
            const category = JSON.parse(s_id)[0].s_cate;
            if (category === '썬가드하이퍼이벤트') 
                return history.push(`/Si_reserve_detail?r_id=${rr_id}&date=${formatDate(value)}`);
            alert('결제가 되지않은 예약건입니다.');
        }else{
            if(window.confirm('작업을 진행하시겠습니까?')){            
                if (e.target.dataset.name === "현장결제") {      
                    if(e.target.dataset.s_id){
                        history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                    }else{
                        history.push('/apply?r_id='+rr_id);
                    }
                }else if(e.target.dataset.name === "앱 결제") {
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }else if(e.target.dataset.name === "입고완료"){
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }else if(e.target.dataset.name === "검수완료"){
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }else if(e.target.dataset.name === "작업완료"){
                    history.push('/Si_reserve_detail?r_id='+rr_id+'&date='+formatDate(value));
                }
            }
        }
    }

    return (
        <div className={classStr} style={btnRadius} onClick={goPage} data-name={str} data-id={r_id} data-s_id={s_id}>{str}</div>
    )

}

function setName(v) {
    let name = '';
    JSON.parse(v.s_id).forEach(function (items) {
        if (JSON.parse(v.s_id).length > 1) {
            name = JSON.parse(v.s_id)[0].s_name + ' 외 ' + JSON.parse(v.s_id).length + '개';
        } else {
            name = JSON.parse(v.s_id)[0].s_name;
        }
    });

    return name;
}

function LoadData({history}) {

    const [data, setData] = useState([]);
    const ppp = 10;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const [r_ipgo, setR_ipgo] = useState(progressDate(0));
    const [active, setActive] = useState(0);

    const [nowDate, setNowDate] = useState(progressDate(0))
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    

    const startChange = (date) => {
        setStartDate(date);
        setNowDate(formatDate(date));
        setActive('custom')
    }
    const endChange = (date) => {
        setEndDate(date);
        setR_ipgo(formatDate(date));
        setActive('custom')
    }
    
    
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const si_id = parsedsigong.u_sigong;

    let obj = {
        page: page,
        ppp: ppp,
        si_id: si_id,
        r_ipgo:r_ipgo,
        nowDate:nowDate
    }
    

    useEffect(() => {

        const fetchData = async () => {
            instance.post('/reserve/progress', obj).then(function (res) {
                setData(res.data.rows);
                setTotal(res.data.totalCount);
            });

        };
        fetchData();
    }, [page, ppp, si_id, r_ipgo,nowDate]);

    const tabSearch = {
        whiteSpace: 'nowrap'
    }
    const grayLine = {
        border: 'solid 1px lightgray',
    }

    const onClick = (e) => {
        const {day} = e.target.dataset;
        setStartDate('');
        setEndDate('');
        setActive(day)
        setR_ipgo(progressDate(day))
        
    }
    const pageChange = (pageNumber) => {
        setPage(pageNumber);
    }


    console.log('data : ', data)

    const ab = {
        position:'absolute',
        right:'23px',
        top:'4px',
        width:'20px'
    }

    const ab2 = {
        position:'absolute',
        right:'8px',
        top:'4px',
        width:'20px'
    }

    return (
        <>
            <div className="container">
                <div className="row mb-4 pl-0 pr-0">
                    <div className="pl-0 col-6" style={{position:'relative'}}>
                        <DatePicker
                            locale="ko"
                            dateFormat="yyyy-MM-dd"
                            className="progress-datepicker form-control text-center text-primary culDate"
                            selected={startDate}
                            onChange={startChange}
                        />
                        <img src={calendar} style={ab}/>
                    </div>
                    <div className="pr-0 col-6" style={{position:'relative'}}>
                        <DatePicker
                            locale="ko"
                            dateFormat="yyyy-MM-dd"
                            className="progress-datepicker form-control text-center text-primary culDate"
                            selected={endDate}
                            onChange={endChange}
                        />
                        <img src={calendar} style={ab2}/>
                    </div>
                </div>
                <div className="row mb-3 px-0 text-center">
                    {
                        active*1 === 0
                        ?<div className="day-span col px-0 font-weight-bold active" onClick={onClick} data-day={0}>오늘</div>
                        :<div className="day-span col px-0 font-weight-bold" onClick={onClick} data-day={0}>오늘</div>
                    }
                    {
                        active*1 === 7
                        ?<div className="day-span col px-0 font-weight-bold active" onClick={onClick} data-day={7}>일주일</div>
                        :<div className="day-span col px-0 font-weight-bold" onClick={onClick} data-day={7}>일주일</div>
                    }
                    {
                        active*1 === 15
                        ?<div className="day-span col px-0 font-weight-bold active" onClick={onClick} data-day={15}>15일</div>
                        :<div className="day-span col px-0 font-weight-bold" onClick={onClick} data-day={15}>15일</div>
                    }
                    {
                        active*1 === 30
                        ?<div className="day-span col px-0 font-weight-bold active" onClick={onClick} data-day={30}>한달</div>
                        :<div className="day-span col px-0 font-weight-bold" onClick={onClick} data-day={30}>한달</div>
                    }
                    {
                        active*1 === 60
                        ?<div className="day-span col px-0 font-weight-bold active" onClick={onClick} data-day={60}>두달</div>
                        :<div className="day-span col px-0 font-weight-bold" onClick={onClick} data-day={60}>두달</div>
                    }
                    {
                        active === "전체"
                        ?<div className="day-span col px-0 font-weight-bold active" onClick={onClick} data-day="전체">전체</div>
                        :<div className="day-span col px-0 font-weight-bold" onClick={onClick} data-day="전체">전체</div>
                    }
                </div>
                <div style={grayLine}></div>
                <div className="row">
                    {
                        data.map(v => <div className="s_calendar_main_content" key={v.r_id}>
                            <div className="S_calendar_content2 pb-3 pt-3">
                                <div className="S_calendar_content">
                                    {v.s_id
                                        ? setName(v)
                                        : <span>-</span>
                                    }
                                </div>
                                <div className="S_calendar_date">{v.r_reserve_date}</div>
                                <span className="S_calendar_money d-block mb-2">
                                    {v.s_id ? totalPrice(JSON.parse(v.s_id),v.co_discount) : <span>-</span>} 원</span>
                                <MakeBtn status={v.r_status} gumsu={v.r_gumsu} enddate={v.r_enddate} gubun={v.r_gubun} r_id={v.r_id} history={history} s_id={v.s_id}/>
                            </div>
                        </div>)
                    }

                </div>
            </div>
            <div className="text-center">
                <Pagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={total}
                    pageRangeDisplayed={10}
                    onChange={pageChange}
                />
            </div>
        </>
    )
}

function progressDate(type){
    
    const d = new Date();
    let result;
    if(type === '전체'){
        result = '전체';
    }else if(type === 0){
        
        result = formatDate(d);
    }else{
        const date = new Date(d.getFullYear(), d.getMonth(), d.getDate() - type);
        result = formatDate(date);
    }    
    
    return result
}


function Progress_list({history}) {

    
    const pbottom = {
        paddingBottom : '90px'
    }
    return (
        <>
            <div style={pbottom}>
            <TopTitle title="작업 내역" />
            <LoadData history={history}/>
            <Bottom_menu />            
            </div>
        </>
    )
}

export default Progress_list;